import { colorTransition } from "@dashboard/utils/motion";
import { Box, List, sprinkles } from "@saleor/macaw-ui-next";
import React, { ReactNode } from "react";
import { Link } from "react-router-dom";

interface HomeNotificationListItemProps {
  dataTestId?: string;
  linkUrl: string;
  children: ReactNode;
}

// Hover tints the whole row and eases in, the way list rows do in most
// component libraries: colour only, no movement, so the row stays a calm
// target; pressing darkens a step further for immediate feedback.
const rowClassName = sprinkles({
  width: "100%",
  padding: 3,
  backgroundColor: {
    default: "transparent",
    hover: "default1Hovered",
    focusVisible: "default1Hovered",
    active: "default1Pressed",
  },
});

export const HomeProductListItem = ({
  dataTestId,
  linkUrl,
  children,
}: HomeNotificationListItemProps) => (
  <List.Item
    borderColor="default1"
    borderWidth={1}
    borderBottomStyle="solid"
    data-test-id={dataTestId}
  >
    <Link
      className={rowClassName}
      style={{ transition: colorTransition("background-color") }}
      to={linkUrl}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        width="100%"
      >
        {children}
      </Box>
    </Link>
  </List.Item>
);
